import { MapPin } from "lucide-react";
import { ZONES } from "@/lib/business";

export const ServiceArea = () => (
  <section id="service-area" data-testid="service-area" className="section-pad bg-white">
    <div className="container-tn">
      <div className="max-w-3xl">
        <span className="eyebrow">Service Area</span>
        <span className="gold-rule" />
        <h2 className="font-serif text-navy uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          I come to you.<br />Five travel zones from River Grove.
        </h2>
        <p className="mt-5 text-mutedink text-base sm:text-lg leading-relaxed">
          Zones are set by approximate driving distance from River Grove (60171). Not sure which zone
          you&apos;re in? Just call — I&apos;ll confirm before we book.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ZONES.map((z) => (
          <div
            key={z.key}
            data-testid={`zone-card-${z.key}`}
            className="relative bg-white border border-navy/10 rounded-md p-6 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_36px_-20px_rgba(26,42,79,0.35)]"
          >
            <div className="flex items-center justify-between border-b border-gold-soft/50 pb-4 mb-4">
              <div className="flex items-center gap-3">
                <span className="flex items-center justify-center w-11 h-11 rounded-md bg-navy text-gold font-serif font-bold text-xl tracking-wider">
                  {z.key}
                </span>
                <div>
                  <p className="font-serif text-navy uppercase text-sm tracking-[0.2em] font-semibold">
                    Zone {z.key}
                  </p>
                  <p className="text-xs text-mutedink flex items-center gap-1 mt-0.5">
                    <MapPin className="w-3 h-3 text-gold" /> {z.range}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-serif text-navy text-2xl font-bold">${z.fee}</p>
                <p className="text-[10px] uppercase tracking-widest text-mutedink">visit fee</p>
              </div>
            </div>
            <ul className="flex flex-wrap gap-x-3 gap-y-1.5 text-sm text-ink">
              {z.towns.map((t) => (
                <li key={t} className="text-mutedink">
                  <span className="text-gold mr-1">·</span>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-10 max-w-4xl bg-surface border-l-4 border-gold rounded-r-md p-5 sm:p-6">
        <p className="text-sm sm:text-base text-ink leading-relaxed">
          <strong className="font-semibold text-navy">Farther out?</strong> Aurora, Joliet, Waukegan,
          the far southwest suburbs, and deeper DuPage / Lake County — welcome by custom quote.
          Not sure which zone you&apos;re in? Just call.
        </p>
      </div>
    </div>
  </section>
);
